// ----------------------------------------------------------------------------
// Component: Rollover
// ----------------------------------------------------------------------------
//
// Generic rollover component.
//
// Requires the following structure:
// .rollover
//     .rollover__under
//     .rollover__over
//
// When the page is scrolled, .rollover__under scrolls over .rollover__over.
// .rollover__under sticks to top of page until the .rollover component
// leaves the page.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './rollover.scss';

/**
 * Gets keyboard-focusable elements within a specified element
 * @param {HTMLElement} [element=document] element
 * @returns {Array}
 */
function getKeyboardFocusableElements (element = document) {
    return [
        ...element.querySelectorAll(
        'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
        )
    ].filter(
        el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')
    )
}

function handleFocusableRolloverElements() {
    let rolloverUnders = document.querySelectorAll('.rollover__under');
    rolloverUnders.forEach(rolloverUnder => {
        let focusableElements = getKeyboardFocusableElements(rolloverUnder);
        focusableElements.forEach(focusableEl => {
            focusableEl.addEventListener('focus', function() {
                window.scrollTo(0, 0);
            })
        })
    })
}

function applyTopValueToRollover() {
    let rolloverEls = document.querySelectorAll('.rollover__under');
    let header = document.querySelector('.header');
    let headerRect = header.getBoundingClientRect();
    let headerHeight = headerRect.height;
    document.documentElement.style.setProperty('--iamota-header-height', `${headerHeight}px`);


    rolloverEls.forEach(function(rollover) {
        //rollover.style.top = `${headerHeight}px`;
    })
}

function initRollovers() {
    applyTopValueToRollover();
    handleFocusableRolloverElements();
}

document.addEventListener('DOMContentLoaded', initRollovers);

window.addEventListener('resize', applyTopValueToRollover);

